<template>
  <div class="content_box">
    <div class="draggable-btn" ref="draggableBtn" @mousedown="startDrag">
      <p @click="setCurrent($event)">一键加购</p>
      <!-- <img src="@/assets/headerimage/yjjrcard.png" alt="拖拽按钮"> -->
    </div>
    <ArawerCard />
    <AppNewHeader :userName="userName" :placeholderText="'请输入数据库名称'" />

    <!-- Banner区域 -->
    <div class="dftsBanner"  v-loading="loading1">
      <div class="Banner">
        <div class="BannerImg">
          <!-- <img
            :style="
              detailsIss
                ? { width: '100%', height: '275px' }
                : { width: '100%', height: '555px' }
            "
            :src="bannerimg"
            alt=""
          /> -->
          <div class="img_iext" v-if="detailsIss">
            <div>
              <span class="banner-text blue">定制化</span>
              <span class="banner-text black">地方特色数据库</span>
            </div>
            <div class="img_content">
              为地方图书馆提供解决方案，助力文旅融合与决策支持
            </div>
          </div>
          <div class="img_iext2" v-if="nameTltle === '公共图书馆'">
            <div>
              <!-- <span class="banner-text2">公共图书馆</span> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 内容区域 -->
    <div
      v-loading="loading1"
      class="content_text"
      :style="detailsIss ? {} : { marginTop: '-123px' }"
      :class="{ 'overlap-banner': detailsIss }"
    >
      <div class="content_item">
        <div class="tableTitle" v-if="detailsIss">
          <img :src="dw01" alt="" />
          {{ nameTltle }}
        </div>

        <!-- 卡片列表 -->
        <div class="cardList">
          <!-- <div class="cardItem" v-for="(item, index) in tableData" :key="index">
            <div class="item">
              <div class="itemType">
                <div @click="handleClick(item)">
                  {{ item.title || "历近代史登科数据库" }}
                </div>
                <div>分类：{{ item.navi || "历史文化" }}</div>
              </div>
              <div class="item_content">
                <p v-html="item.description || defaultDescription"></p>
              </div>
              <div class="botList">
               
                <div class="but_item">
                  <div class="but_item1" @click="handleClick(item)">详情</div>
                  <div
                    class="but_item2"
                    @click="triggerParentEvent(item, $event)"
                  >
                    <img
                      style="height: !4px; width: 14px"
                      :src="imge0"
                      alt="采购图标"
                    />
                    <span style="padding-left: 4px">采购</span>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
       <div class="knowledge-cards">
        <div>
          <el-table
            :show-header="false"
            :data="filteredKnowledgeCards"
            @selection-change="handleSelectionChange"
            @select-all="handleall"
            ref="tableRef"
            :header-cell-class-name="headerCellStyle"
            :row-class-name="tableRowClassName"
          >
            <!-- <el-table-column type="selection" width="25px" /> -->
            <el-table-column  prop="titleHtml" width="1170px"  >
              <template #default="scope">
                <div class="knowdegritem">
                  <img
                    style="width: 160px; height: 90px;border: 1px solid #ebeef5;"
                    :src="getImagePath2(scope.row.imgUrl)"
                    @mouseenter="showBigImg(scope.row.imgUrl, $event)"
                    @click="showBigImg(scope.row.imgUrl, $event)"
                    @mouseleave="hideBigImg(scope.row.imgUrl, $event)"
                    alt=""
                    v-if="scope.row.imgUrl"
                  />
                  <div class="knowdege_center" :class="!scope.row.imgUrl?'knowdege_center1':''">
                    <div class="knoedege_text_cont" :class="{knoedege_text_cont1:!scope.row.imgUrl}">
                      <div class="knowdegList_title">
                        <p
                          @click="datebaseinfo(scope.row)"
                          v-html="scope.row.title"
                          :title="scope.row.title"
                        ></p>
                        <!-- <div>HOT</div> -->
                      </div>

                      <div>
                        <p
                          :title="stripHtmlTags(scope.row.description)"
                          class="description-text"
                          v-html="scope.row.description || '暂无简介'"
                        ></p>
                      </div>
                      <div class="knoedege_fwfs">
                        <div>网络访问</div>
                        <div>镜像访问</div>
                        <div
                          @click="handlejpzskinffo(scope.row, $event)"
                          class="knowdege_jianjie"
                        >
                          简介
                        </div>
                      </div>
                    </div>
                    <div class="knowdege_but">
                      <div class="but_count" v-show="scope.row.useCount&&scope.row.useCount!=0">
                        使用量:{{ scope.row.useCount }}
                      </div>
                      <div
                        class="but_addcard"
                        @click="triggerParentEvent(scope.row, $event)"
                      >
                        加入采购清单
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <transition name="fade">
            <div
              v-if="jzzsktype"
              class="overlay"
              @click="handlejpzskinffo"
            ></div>
          </transition>

          <transition name="popover">
            <div
              class="zpzsk_Popover"
              v-if="jzzsktype"
              :style="{
                position: 'absolute',
                top: `${clickPosition.top}px`,
                left: `${clickPosition.left}px`,
                transform: 'translateX(-50%)',
              }"
            >
              <p class="jpzsk_title">{{ currentItem?.title }}</p>
              <p
                class="jpzsk_content"
                v-html="currentItem?.description || '暂无简介'"
              ></p>
            </div>
          </transition>
          <transition name="fade">
            <div class="image-box-viewer" id="imageBoxViewer" :style="{top: `${imgPosition.top}px`,
                  left: `${imgPosition.left}px`, border: 'none',position: 'absolute',width:'950px',zIndex:'99'}" v-if="bigImgVisable">
              <div class="viewer-image" style="box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);">
                <!-- <div class="load" style="display: none;">
                  <span class="load-icon"></span>
                </div> -->
                <img style="width: 100%;" :src="bigImg"  />
              </div>
            </div>
          </transition>
          <div
            class="kongEmpoty"
            v-if="filteredKnowledgeCards.length === 0 && searchComplete"
          >
            <div class="kongEmpotyimg">
              <img :src="kongzt" alt="" />
              <div class="kongEmpotytext">
                <p>
                  您搜索的知识库平台暂未收录，我们的小伙伴们正在抓紧时间搜录，如果您有相关的知识库推荐，<span
                    @click="handlecooperation"
                    >联系我们</span
                  >
                </p>
              </div>
            </div>
          </div>
          <div class="pageClass" v-if="counttotal > 0">
            <el-pagination
              :page-size="pageSize"
              :pager-count="count"
              layout="prev, pager, next"
              @current-change="handleCurrentChange"
              :total="counttotal"
              :current-page="currentPage"
            />
          </div>
        </div>
      </div>
    
        </div>
      </div>
    </div>

    <el-footer>
      <AppFooter />
    </el-footer>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, onUnmounted,watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import AppFooter from "@/views/components/AppFooter.vue";
import AppNewHeader from "@/views/components/AppNewHeader.vue";
import ArawerCard from "@/views/components/ArawerCard.vue";
import banner01 from "@/assets/headerimage/dftsBanner.png";
import banner02 from "@/assets/headerimage/banner02.png";
import banner03 from "@/assets/headerimage/banner03.png";
import banner04 from "@/assets/headerimage/banner04.png";
import banner05 from "@/assets/headerimage/banner05.png";
import dw01 from "@/assets/headerimage/dingwei.png";
import imge0 from "@/assets/headerimage/card002.png";
import bus from "@/mitt/bus.js";
import { ElMessage } from "element-plus";
import { Cookie } from "@/utils/Cookie";
import {
  PostUserCarList,
  PostProvienKnowList,
  PostBusInessKnmwList,
  getBuyLog,
} from "@/api/index.js";
import { usePageStayTime } from "@/utils/usePageStayTime";
const router = useRouter();
const route = useRoute();
const { stayTime, totalStayTimes } = usePageStayTime();
const loading1 = ref(true);
// 响应式数据
const detailsIss = ref(false);
const bannerimg = ref(banner01);
const filteredKnowledgeCards = ref([]);
const bigImg = ref(null)
const bigImgVisable = ref(false);

const tableData = ref([]);
const nameTltle = ref("");
const id2value = ref(route.query.id2 || "396");
const id1value = ref(route.query.id || "2");
const textValue = ref(route.query.name || '政府部门');
const defaultDescription = "暂无简介";
const weburl = ref(window.location.href);
const isDragging = ref(false);
const userName = ref("");
const currentItem = ref([]);

const jzzsktype = ref(false);
const clickPosition = ref({
  top: 0,
  left: 0,
  width: 0,
});
const imgPosition = ref({
  top: 0,
  left: 0,
  width: 0,
});
watch(
  () => route.query,
  (newQuery, oldQuery) => {
    if (oldQuery && (newQuery.id2 !== oldQuery.id2 || newQuery.name !== oldQuery.name)) {
      window.location.reload()
    }
  },
  { deep: true }
)
const checkTokenStatus = async () => {
  const token = JSON.parse(Cookie.get("token")) || "";
  if (token && !isTokenExpired(token)) {
    const userString = JSON.parse(Cookie.get("userInfo")) || null;
    const user = userString || null;
        userName.value = user?.realName;;
  }
};

const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (payload.exp) {
      return Date.now() >= payload.exp * 1000;
    }
    return false; 
  } catch (e) {
    return true; 
  }
};
const handleLog = async () => {
  try {
    const res = await getBuyLog({
      type: "7",
      url: weburl.value,
      text: textValue.value,
      second: stayTime._value,
    });
    if (res) {
    }
  } catch (error) {
    console.log(error);
  }
};
const hiddenTime = ref(Number);

window.addEventListener("load", async () => {
  const stored = localStorage.getItem("lastSelectTime");
  hiddenTime.value = Math.floor((Date.now() - stored) / 1000);
  try {
    const res = await getBuyLog({
      type: "7",
      url: weburl.value,
      second: hiddenTime.value,
    });
    if (res.status == 200) {
      localStorage.setItem("lastSelectTime", Date.now().toString());
    }
  } catch (error) {
    console.log(error);
  }
});
const getImagePath2 = (filePath) => {
  const baseApi = process.env.VUE_APP_BASE_API;
  if (baseApi) {
    return process.env.VUE_APP_BASE_API + "/ckbop" + filePath;
  } else {
    return "/ckbop" + filePath;
  }
};
const stripHtmlTags = (html) => {
  if (!html) return "";
  const tmp = document.createElement("div");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
};

const showBigImg = (url, event) => {
  const clickElement = event.currentTarget;
  const rect = clickElement.getBoundingClientRect();
  
  // 创建临时图片获取尺寸
  const tempImg = new Image();
  tempImg.src = getImagePath2(url);
  
  tempImg.onload = () => {
    // debugger
    const imgWidth1 = tempImg.width;
    const imgHeight1 = tempImg.height;

    const imgWidth = 950;
    const imgHeight = Math.ceil((imgHeight1*950)/imgWidth1);
    
    // 获取视口尺寸
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    
    let left = rect.left + window.scrollX - imgWidth - 10; 
    
    if (left < window.scrollX) {
      left = rect.right + window.scrollX + 10; 
    }
    
    // 确保图片不超出视口顶部
    // if (top < window.scrollY) {
    //   // top = window.scrollY + 15;
    //   top = rect.top - 100;
    // }
    
    let top = rect.top + window.scrollY;
    // 确保图片不超出视口底部
    if (rect.top > viewportHeight - imgHeight) {
      // top = rect.top - (top+imgHeight-viewportHeight) -rect.bottom;

      top =rect.top + window.scrollY-336 -(imgHeight - (viewportHeight- rect.top)) ;
    }
    else{
      top = top - 330;
    }
    
    imgPosition.value = {
      top,
      left,
      width: imgWidth,
    };
    
    bigImg.value = getImagePath2(url);
    bigImgVisable.value = true;
  };
  
  tempImg.onerror = () => {
    console.error('图片加载失败:', url);
    // 可以显示默认图片或错误提示
  };
};

// 初始化页面数据
onMounted(async () => {
 await checkTokenStatus();

  initializePageData();
  window.addEventListener("mousemove", onDrag);
  window.addEventListener("mouseup", stopDrag);
});
onBeforeUnmount(() => {
  window.removeEventListener("mousemove", onDrag);
  window.removeEventListener("mouseup", stopDrag);
});
onUnmounted(async () => {
  await handleLog();
});
// 页面数据初始化
const initializePageData = async () => {
  // loading1.value = true;
  try {
    if (route.query.id) {
      await fetchProvinceData(id1value.value);
      nameTltle.value = `${route.query.id}地方特色数据库`;
      bannerimg.value = banner01;
      detailsIss.value = true;
    } else if (route.query.id2) {
      await fetchBusinessData(id2value.value);
      nameTltle.value =textValue.value || "应用领域";
      detailsIss.value = false;
      updateBannerImage(nameTltle.value);
      loading1.value = false;
    }else{
      await fetchBusinessData(id2value.value);
      nameTltle.value =textValue.value || "应用领域";
      detailsIss.value = false;
      updateBannerImage(nameTltle.value);
      loading1.value = false;
    }
  } catch (error) {
    // loading1.value = true;
    console.error("初始化页面数据失败:", error);
  }
};

// 根据标题更新banner图片
const updateBannerImage = (title) => {
  const bannerMap = {
    政府部门: banner02,
    科研单位: banner03,
    公共图书馆: banner04,
    高校图书馆: banner05,
  };
  bannerimg.value = bannerMap[title] || banner01;
};

// 获取省份数据
const fetchProvinceData = async (id) => {
  loading1.value = true;
  const res = await PostProvienKnowList({ areaCode: id });
  if (res?.info) {
    filteredKnowledgeCards.value = res.info;
    loading1.value = false;
  }
};

// 获取业务数据
const fetchBusinessData = async (id) => {
  const res = await PostBusInessKnmwList({ bussinessCid: id });
  if (res?.info) {
    filteredKnowledgeCards.value = res.info;
  }
};

// 查看详情
const handleClick = (row) => {
  localStorage.setItem("lastSelectTime", Date.now().toString());
  if (!row?.id) return;
  router.push({
    path: "newDatabaseInfo",
    query: { id: row.id },
  });
};

// 触发父组件事件
const triggerParentEvent = (card, event) => {
  if (!card) return;
  bus.emit("sendMsg", {
    message: "Hello from SenderComponent!",
    card,
    event,
  });
};
const prepareCartData = () => {
  return filteredKnowledgeCards.value
    .filter((item) => item?.id)
    .map((item) => ({
      knowledgeId: item.id,
      knwoledgeTitle: item.title,
      publishUnit: item.publishUnit,
      knowledgeVersion: "netVersion",
      netVersion: item.netVersion,
      mirrorVersion: item.mirrorVersion,
      netPrice: item.netPrice,
      mirrorPrice: item.mirrorPrice,
      netPrice20: item.netPrice20,
      netPrice50: item.netPrice50,
      netPrice100: item.netPrice100,
      netPrice200: item.netPrice200,
    }));
};
const prepareCartData2 = () => {
  return filteredKnowledgeCards.value
    .filter((item) => item?.id)
    .map((item) => ({
      knowledgeId: item.id,
      id: item.id,
      knwoledgeTitle: item.title,
      publishUnit: item.publishUnit,
      knowledgeVersion: "netVersion",
      netVersion: item.netVersion,
      mirrorVersion: item.mirrorVersion,
      netPrice: item.netPrice,
      mirrorPrice: item.mirrorPrice,
      netPrice20: item.netPrice20,
      netPrice50: item.netPrice50,
      netPrice100: item.netPrice100,
      netPrice200: item.netPrice200,
    }));
};
// 一键加入购物车
const checkAuth = () => {
  const token = JSON.parse(Cookie.get("token")) || "";
  if (!token || isTokenExpired(token)) {
    ElMessage.warning("请先登录");
    router.push("/login");
    return false;
  }
  return true;
};

const setCurrent = async (event) => {
  // 检查是否正在进行拖拽，如果正在拖拽则不执行点击事件
  if (isDragging.value) return;

  try {
    // First check token status
    const token = JSON.parse(Cookie.get("token")) || "";
    // if (!token || isTokenExpired(token)) {
    //   ElMessage.warning("请先登录");
    //   // router.push("/login"); // Redirect to login page
    //   return;
    // }

    const selectedData = prepareCartData();
    if (selectedData.length === 0) return;

    const response = await PostUserCarList({ cart: selectedData });
    if (response.success) {
      ElMessage.success("一键加入成功");
      triggerParentEvent(prepareCartData(), event);
    }
  } catch (error) {
    console.error("加入购物车失败:", error);
    if (error.response && error.response.status === 401) {
      ElMessage.warning("登录已过期，请重新登录");
      // router.push("/login");
    } else {
      // console.log( prepareCartData());

      localStorage.setItem(
        "addCardListParams",
        JSON.stringify(prepareCartData2())
      );
      triggerParentEvent(prepareCartData2(), event);
      ElMessage.success(`${prepareCartData2().length}个项目已添加到购物车`);
    }
  }
};
const handlejpzskinffo = (row, event) => {
  currentItem.value = row;
  jzzsktype.value = !jzzsktype.value;

  // 保存点击位置信息
  if (jzzsktype.value) {
    const clickElement = event.currentTarget;
    const rect = clickElement.getBoundingClientRect();
    clickPosition.value = {
      top: rect.bottom + window.scrollY - 370,
      left: rect.left + window.scrollX + 180,
      width: rect.width,
    };
  }

  // 禁止/恢复滚动
  if (jzzsktype.value) {
    document.body.style.overflow = "hidden";
    document.body.style.paddingRight = `${15}px`;
  } else {
    document.body.style.overflow = "";
    document.body.style.paddingRight = `${0}px`;
  }
};
const hideBigImg = ()=>{
  bigImgVisable.value = false;
}

const draggableBtn = ref(null);
let offsetX = 0;
let offsetY = 0;

const startDrag = (e) => {
  isDragging.value = true;
  const rect = draggableBtn.value.getBoundingClientRect();
  offsetX = e.clientX - rect.left;
  offsetY = e.clientY - rect.top;

  // 防止文本选中
  document.body.style.userSelect = "none";
};

const onDrag = (e) => {
  if (!isDragging.value) return;

  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;
  const btnWidth = draggableBtn.value.offsetWidth;
  const btnHeight = draggableBtn.value.offsetHeight;

  let newX = e.clientX - offsetX;
  let newY = e.clientY - offsetY;

  // 限制X轴位置
  if (newX < 0) {
    newX = 0;
  } else if (newX > windowWidth - btnWidth) {
    newX = windowWidth - btnWidth;
  }

  // 限制Y轴位置
  if (newY < 0) {
    newY = 0;
  } else if (newY > windowHeight - btnHeight) {
    newY = windowHeight - btnHeight;
  }

  draggableBtn.value.style.left = `${newX}px`;
  draggableBtn.value.style.top = `${newY}px`;
};

const stopDrag = () => {
  isDragging.value = false;
  document.body.style.userSelect = "";
};

const handleDragEnd = (e) => {
  e.target.style.opacity = "1";
  // 获取最终位置
  const x = e.clientX;
  const y = e.clientY;
  console.log(`按钮被拖拽到位置: (${x}, ${y})`);
};
</script>

<style scoped>
/* 原有样式全部保留 */
.content_box {
  background: #f5f5f5;
}
.el-footer {
  --el-footer-padding: 0;
  --el-footer-height: 0;
  box-sizing: border-box;
  flex-shrink: 0;
  height: var(--el-footer-height);
  padding: var(--el-footer-padding);
}
.content_text {
  width: 100%;
  display: flex;
  justify-content: center;
  background: #f5f5f5;
}
.content_item {
  width: 1400px;
  min-height: 750px;
  z-index: 2;
  background: #fff;
}

.tableTitle > img {
  width: 16px;
  height: 16px;
}
.dftsBanner {
  width: 100%;
  /* height: 276px; */
}
.BannerImg {
  /* width: 100%;
  height: 276px; */
  position: relative;
  background: url(../../assets/headerimage/dftsBanner.png) no-repeat top center #3040d1;
  height: 200px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position:center;
}
.img_iext {
  position: absolute;
  left: 346px;
  top: 50px;
}
.img_iext2 {
  position: absolute;
  left: 873px;
  top: 59px;
}
.banner-text2 {
  font-weight: normal;
  font-size: 34px;
  color: #139bad;
  font-style: normal;
}
.img_content {
  font-family: SourceHanSansSC, SourceHanSansSC;
  font-weight: 400;
  font-size: 20px;
  color: #707070;
  line-height: 29px;
  text-align: left;
  font-style: normal;
}
.cardList {
  display: flex;
  /* justify-content: space-between; */
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 30px;
  background: #fff;
}
.item {
  width: 694px;
  height: 150px;
  background: #ffffff;
  /* border-radius: 6px; */
}
.itemType {
  display: flex;
  justify-content: space-between;
  padding: 16px 22px 8px 16px;
}
.item_content > p {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 40px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  line-height: 20px;
  text-align: justify;
  font-style: normal;
  padding: 0px 22px 0px 16px;
  margin: 0;
}
.botList {
  display: flex;
  justify-content: space-between;
  padding: 20px 16px 0px 16px;
}
.botlist1 {
  display: flex;
  justify-content: space-between;
}
.but_item {
  display: flex;
  justify-content: space-between;
}
.but_item1 {
  width: 78px;
  height: 30px;
  background: rgba(255, 255, 255, 0);
  /* border-radius: 4px; */
  border: 1px solid #2c77ff;
  line-height: 30px;
  text-align: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #2c77ff;
  font-style: normal;
  cursor: pointer;
}
.but_item1:hover {
  background: #2c77ff;
  color: #fff;
}
.but_item2 {
  width: 78px;
  height: 32px;
  background: #2c77ff;
  /* border-radius: 4px; */
  line-height: 32px;
  text-align: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  font-style: normal;
  margin-left: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.but_item2:hover {
  background: #2565d9;
}
.itemType > div:nth-child(1) {
  font-family: PingFangSC;
  font-weight: 500;
  font-size: 16px;
  color: #333333;
  text-align: left;
  font-style: normal;
  cursor: pointer;
}
.itemType > div:nth-child(1):hover {
  color: #2c77ff;
}
.itemType > div:nth-child(2) {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  text-align: center;
  font-style: normal;
}
.mirrpire {
  margin-left: 10px;
}
.price-divider {
  width: 17px;
  height: 12px;
  border-right: 1px solid rgb(235, 235, 235);
  margin-top: 10px;
}

/* 新增样式 - 不影响原有样式 */
.overlap-banner {
  position: relative;
  z-index: 1;
}

.banner-text {
  font-family: SourceHanSansSC, SourceHanSansSC;
  font-weight: bold;
  font-size: 40px;
  line-height: 59px;
  text-align: left;
  font-style: normal;
}
.blue {
  color: #1568ff;
}
.black {
  color: #383838;
}
.price-symbol {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 13px;
  color: #fe5c5c;
  line-height: 25px;
}
.price-value {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 18px;
  color: #fe5c5c;
  line-height: 25px;
  text-align: left;
  font-style: normal;
}
.price-label {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  line-height: 17px;
  text-align: left;
  font-style: normal;
  padding-left: 5px;
}

.knowledge-container {
  display: flex;
}

.knowledge-nav {
  width: 210px;
  height: 68px;
  opacity: 1;
  scrollbar-width: none;
  -ms-overflow-style: none;
  /* border-radius: 10px; */
  background: #fff;
  /* border-top-left-radius: 12px;
  border-top-right-radius: 12px; */
  /* background-image: url(@/assets/newimages/zskflnavimg.png); */
  /* background-repeat: no-repeat;
  background-size: cover; */
  border-bottom: 1px solid #e4e7ed;
}

.knowledge-nav::-webkit-scrollbar {
  width: 0;
}

.knowledge-nav::-webkit-scrollbar {
  width: 0; /* 隐藏WebKit浏览器的滚动条 */
}
.nav-title {
  width: 210px;
  height: 61px;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 61px;
  color: rgba(255, 255, 255, 1);
  text-align: left;
  padding-left: 20px;
  /* padding: 20px 0 0 20px ; */
  vertical-align: top;
  background-image: url(@/assets/headerimage/nav2back.png);
}

.nav-menu {
  width: 210px;
  height: auto;
  /* background: #e1ebff; */
  /* border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px; */
  padding-bottom: 3px;
}
.knowledge-cards {
  /* padding-left: 20px; */
  width: calc(100% - 210px);
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  min-height: 700px;
}

.knowledge-card {
  position: relative;
  width: 580px;
  height: 118px;
  background: #f4f6fa;
  border-radius: 6px;
  margin-left: 10px;
  float: left;
}
.knowledge-card:hover {
  background: #ecf2ff;
  cursor: pointer;
}
.knowledge-card:hover .card-name {
  color: rgba(33, 79, 219, 1);
}
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.card-header div:hover {
  color: #2c77ff;
}
.card-name {
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 1px;
  line-height: 21.12px;
  color: rgba(56, 56, 56, 1);
  text-align: left;
  vertical-align: top;
}

.card-content {
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 22px;
  color: rgba(153, 153, 153, 1);
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 4px;
  text-align: justify;
}

.card-bottom-buttons {
  position: absolute;
  bottom: 23px;
  left: 26px;
  display: flex;
  justify-content: left;
}
.el-menu {
  border: none;
  border-right: 1px solid #f3f6ff;
}
.nav-menu .el-menu-item.is-active {
  /* background: #eff5ff; */
  background-color: #1c6bfb;
  color: #ffffff;
}
.el-menu-item:hover {
  background-color: #ffffff !important;
  color: #1c6bfb;
}
.is-active:hover {
  background-color: #1c6bfb !important;
  color: #ffffff;
}
.nav-menu .el-menu-item {
  width: 210px;
  height: 48px;
  /* margin: 10px; */
  padding: 10px 30px !important;
  /* border-radius: 4px; */
}
.nav-menu .el-menu-item:first-child {
  margin-top: 15px;
}
.contertext {
  display: flex;
  justify-content: space-between;
}
.contertext2 {
  display: flex;
  justify-content: space-between;
}
.card-titles {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 1px;
  line-height: 26.4px;
  color: rgba(56, 56, 56, 1);
  text-align: left;
  text-align: left;
  vertical-align: top;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.custom-button:hover {
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 0px;
  line-height: 23.94px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  vertical-align: top;
  background: rgba(31, 85, 222, 1);
}
.knowledge-card:hover .card-titles {
  color: rgba(31, 85, 222, 1);
}

.custom-button {
  width: 162px;
  height: 42px;
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 0px;
  line-height: 23.94px;
  color: rgba(24, 24, 24, 1);
  text-align: center;
  vertical-align: top;
  border-radius: 0;
  background: #fff;
  cursor: pointer;
}

:deep(.custom-menu-item) {
  transition: all 0.3s ease; /* 添加过渡效果 */
}

/* 鼠标悬停状态 */
:deep(.custom-menu-item:hover) {
  background: rgba(255, 255, 255, 0.09);
  box-shadow: 0px 2px 5px rgba(137);
}
.pageClass {
  width: 100%;
  height: 52px;
  background: #fff;
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
  margin-top: 40px;
}
.know_nav {
  width: 210px;
  height: 50px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  position: relative;
}
.know_nav span {
}

.know_nav:hover {
  /* color: #2c77ff; */
}
.knowIcon {
  position: absolute;
  right: 0;
  top: 0px;
  width: 60px;
  height: 56px;
}
.knowIcon > img {
  width: 60px;
  height: 56px;
}

.fw_list {
  display: flex;
  gap: 12px; /* 按钮间距 */
  margin-top: 10px;
}

.fw_item {
  display: flex;
  align-items: center; /* 垂直居中 */
  gap: 4px; /* 图标和文字间距 */
  cursor: pointer;
}
.fw_item2 .fw_img2 {
  width: 12px;
  height: 12px;
}
.fw_item2 {
  /* width: 14px; */
  /* height: 14px; */
  display: flex;
  align-items: center;
}

.fw_img {
  width: 12px;
  height: 12px;
  display: flex;
  align-items: center;
}

.fw_name {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  line-height: 1; /* 去除默认行高影响 */
}
.fw_name:hover {
  color: #4a78cd;
}

.cbsText {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  line-height: 17px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bot_but {
  display: flex;
  justify-content: space-between;
  margin-top: 11px;
}
.but_item {
  display: flex;
  justify-content: space-between;
}
.but_item1 {
  width: 78px;
  height: 32px;
  background: rgba(255, 255, 255, 0);
  border-radius: 4px;
  border: 1px solid #2c77ff;
  line-height: 32px;
  text-align: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #2c77ff;
  font-style: normal;
}
.but_item1:hover {
  background: #2c77ff;
  color: #fff;
}
.but_item2 {
  width: 78px;
  height: 32px;
  background: #2c77ff;
  border-radius: 4px;
  line-height: 32px;
  text-align: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  font-style: normal;
  margin-left: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.but_item2:hover {
  background: #2565d9;
}
:deep(.el-card.is-always-shadow),
:deep(.el-card.is-hover-shadow:focus),
:deep(.el-card.is-hover-shadow:hover) {
  box-shadow: none !important;
}
.el-card.is-always-shadow {
  border: none !important;
  box-shadow: none !important;
  margin-left: 10px;
  margin-top: 10px;
}
.kongEmpoty {
  width: 100%;
  /* height: 100%; */
}

.kongEmpotyimg {
  width: 100%;
  height: 100%; /* 确保容器有明确高度 */
  display: flex;
  flex-direction: column; /* 垂直排列子元素 */
  justify-content: center; /* 垂直居中 */
  align-items: center; /* 水平居中 */
  text-align: center; /* 文字水平居中（针对文本容器） */
  margin-top: 115px;
}
.kongEmpotyimg img {
  width: 200px;
  height: 200px;
}
.kongEmpotytext p {
  text-align: center;
  margin-top: 20px;
  color: #333;
  font-size: 14px;
}
.kongEmpotytext p span {
  color: #2c77ff;
  cursor: pointer;
}

.selectbut {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #2c77ff;
  line-height: 34px;
  text-align: left;
  font-style: normal;
  cursor: pointer;
}

.nav-menu .el-menu-item {
  /* background: #2c77ff; */
  /* margin: 10px 10px 0 10px; */
}
.el-checkbox.el-checkbox--large {
  height: 20px;
  display: flex;
  align-items: center;
}

::v-deep .el-table__body tr {
  background-color: var(--el-table-tr-bg-color);
  height: 60px;
}

::v-deep .el-table__header th {
  height: 45px;
  line-height: 45px;
  background: #fafbfc;
}

::v-deep .el-table .even-row {
  background: rgba(242, 242, 242, 0);
  /* cursor: pointer; */
}
::v-deep .el-table .odd-row {
  background: #fafbfc;
  /* cursor: pointer; */
}
::v-deep .el-table.is-scrolling-none th.el-table-fixed-column--left,
::v-deep .el-table.is-scrolling-none th.el-table-fixed-column--right {
  background: #fafbfc;
}
::v-deep .hide-selection-header .cell {
  display: none;
}
.description-text {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  line-height: 1.5;
  max-height: 3em;
  padding-top: 8px;
}
.tableTitle {
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  cursor: pointer;
  padding-left: 105px;
  /* padding: 25px 0; */
  padding-top: 25px;
  padding-bottom: 25px;
}
.tableTitle:hover {
  color: #2c77ff;
}
.knowheader {
  text-align: right;
}

.knowdegritem {
  display: flex;
  /* justify-content: space-between; */
  padding: 12px 0px 12px 0;
  /* gap: 15px; */
}
.knowdegList_title {
  display: flex;
  gap: 13px;
  align-items: center;
}
.knowdegList_title p:hover {
  color: #1c6bfb;
  cursor: pointer;
}
.knowdegList_title p {
  font-size: 16px;
  font-weight: 500;
  color: #333333;

}

.knowdegList_title div {
  width: 33px;
  height: 20px;
  background: #f14748;
  font-size: 12px;
  font-weight: 900;
  text-align: center;
  color: #ffffff;
  line-height: 20px;
}
.knoedege_fwfs {
  display: flex;
  gap: 8px;
  margin-top: 11.5px;
}
.knoedege_fwfs div {
  width: 60px;
  height: 24px;
  background: #f7f7f7;
  border: 0.5px solid #e4e7ed;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  line-height: 22px;
  color: #999999;
}
.knoedege_text_cont {
  width: 741px;
  position: relative;
  margin-left: 15px;
}
.knoedege_text_cont1{
  width: 901px;
}
.knoedege_text_cont::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 1px;
  background-color: #e4e7ed;
  margin-right: -15px;
}
.knowdege_center {
  display: flex;
  justify-content: space-between;
  width: 976px;
}
.knowdege_center1{
  width: 1136px;
}
.but_count {
  font-size: 12px;
  font-weight: 400;
  color: #999999;
  /* text-align: center; */
  padding-left: 24px;
}
.but_addcard {
  width: 120px;
  height: 33px;
  border: 1px solid #f97619;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  line-height: 33px;
  color: #f97619;
  margin-top: 8px;
}
.but_addcard:hover {
  background: #f97619;
  cursor: pointer;
  color: #fff;
}
.knowdege_but {
  width: 180px;
  padding-left: 40px;
}

.icon_but {
  font-size: 12px;
  color: #cacaca;
  width: 14px;
  height: 14px;
  text-align: center;
  line-height: 14px;
  margin-left: 20px;
  border: solid 0.5px #cacaca;
  cursor: pointer;
}

.knoedege_fwfs .knowdege_jianjie {
  width: 36px;
  height: 24px;
  border: 0.5px solid #e4e7ed;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  color: #666666;
  line-height: 22px;
  padding-left: 4px;
  background: #fff;
}
.knoedege_fwfs .knowdege_jianjie:hover {
  border: 0.5px solid #1c6bfb;
  color: #1c6bfb;
  cursor: pointer;
}
.cpfl_header_icon {
  display: flex;
  align-items: center;
  gap: 7px;
}
.cpfl_header_icon img {
  width: 16px;
  height: 16px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}
.zpzsk_Popover {
  z-index: 1000;
  background: white;
  padding: 15px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  max-width: 400px;
  position: fixed; /* 或者 absolute */
}

.jpzsk_title {
  padding-bottom: 20px;
  font-size: 14px;
  color: #333;
  font-weight: bold;
}
.zpzsk_Popover .jpzsk_content {
  font-size: 14px;
  color: #333;
}


::v-deep .el-table .cell {
  padding: 0;
  padding-left: 10px;
}
:v-deep .el-table .el-table__cell{
  padding: 0;
}

.el-table .custom-row:hover > td {
  background-color: red !important;
}

.draggable-btn {
  position: fixed;
  right: 30px;
  bottom: 400px;
  width: 226px;
  height: 107px;
  /* border-radius: 50%; */
  /* background-color: #2c77ff; */
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: move;
  /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2); */
  z-index: 1000;
  transition: opacity 0.3s;
  background-image: url(@/assets/headerimage/yjjrcard01.png);
  background-size: cover;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 15px;
  color: #333333;
  line-height: 21px;
  text-align: center;
  font-style: normal;
  /* cursor: pointer; */
}
.draggable-btn p {
  font-size: 15px;
  color: #333333;
  width: 78px;
  margin-left: 50px;
  cursor: pointer;
}
.draggable-btn :hover {
  color: #2c77ff;
}
</style>
